import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react";

import { ICard } from "../../../../api/cards/types.ts";
import { getPaymentMethodName } from "../../../../utils";
import { useDeleteCardMutation } from "../../../../api/cards";

interface Props {
  card: ICard;
  onCancel: () => void;
  hideModal: () => void;
  blockModalClosing: (state: boolean) => void;
}

export function CardItemDeletionModal({ card, onCancel, hideModal, blockModalClosing }: Props) {
  const { mutateAsync, isPending, isError } = useDeleteCardMutation();
  const paymentName = getPaymentMethodName(card);

  const onDelete = async () => {
    blockModalClosing(true);

    try {
      await mutateAsync(card.productId ?? "");
      hideModal();
    } catch (err) {
      console.error(err);
    } finally {
      blockModalClosing(false);
    }
  };

  return (
    <Stack pt="0px" px="4px" spacing={0}>
      <Heading fontSize="xl">Удалить способ оплаты</Heading>
      <Heading fontSize="xl">{`${paymentName} ?`}</Heading>

      {isError && (
        <Box h="18px" mt="8px">
          <Text fontSize="13px" lineHeight="18px" variant="red">
            Не удалось удалить способ оплаты. Попробуйте ещё раз.
          </Text>
        </Box>
      )}

      <Button mt="21px" colorScheme="brand" isLoading={isPending} onClick={onDelete}>
        Удалить
      </Button>

      <Button mt="6px" borderRadius="18px" isDisabled={isPending} onClick={onCancel}>
        Отмена
      </Button>
    </Stack>
  );
}
